import { Modifier } from '../modifier';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Distracted extends Modifier {
  static readonly baseTitle = 'Distracted';
  static readonly baseText = 'Banes with keyword Stable other than this will not fade. Stable.';
  static readonly baseIcon = 'distracted';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Last;

  // Instance properties initialized from static values
  title = Distracted.baseTitle;
  text = Distracted.baseText;
  icon = Distracted.baseIcon;
  tags = [...Distracted.baseTags];
  priority = Distracted.basePriority;

  update(stacks: number, params?: ModifierParams) {
    super.update(stacks, params);
    this.delay = true;
  }

  startTurn() {
    this.delay = false;
  }

  endTurn() {
    if (!this.delay) {
      this.removeStacks(1);
    }
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Distracted, Distracted);
